// extracted by mini-css-extract-plugin
export default {"dashboardHome":"dashboardHome_dashboardHome__b4qLC","progress":"dashboardHome_progress__2efuX"};